<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      persistent
      scrollable
      :retain-focus="false"
      transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title class="pb-0">
        {{ currentView.title }}
        <v-spacer/>
        <v-btn icon plain :ripple="false" class="btn-close" @click="$emit('close')">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <component :is="currentView.components" :name="name" />
<!--        <template v-if="flag === 0">-->
<!--          <ServiceTerms/>-->
<!--        </template>-->
<!--        <template v-else-if="flag === 1">-->
<!--          <PersonalInfoTerms/>-->
<!--        </template>-->
<!--        <template v-else-if="flag === 2">-->
<!--          <MarketingTerms/>-->
<!--        </template>-->
<!--        <template v-else-if="flag === 3">-->
<!--          <PersonalInfoTermsAll/>-->
<!--        </template>-->
<!--        <template v-else-if="flag === 4">-->
<!--          <PrivacyCollectionTerms/>-->
<!--        </template>-->
<!--        <template v-else-if="flag === 5">-->
<!--          <PrivacyOfferTerms :name="name"/>-->
<!--        </template>-->
<!--        <template v-else-if="flag === 6">-->
<!--          <PersonalInformationAgreement :name="name"/>-->
<!--        </template>-->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Close from '@/components/icons/Close'
import ServiceTerms from './details/ServiceTerms'
import PersonalInfoTerms from './details/PersonalInfoTerms'
import MarketingTerms from './details/MarketingTerms'
import PersonalInfoTermsAll from './details/PersonalInfoTermsAll'
import PrivacyCollectionTerms from './details/PrivacyCollectionTerms'
import PrivacyOfferTerms from './details/PrivacyOfferTerms'
import PersonalInformationAgreement from './details/PersonalInformationAgreement'
import PrivacyTerms from './details/PrivacyTerms.vue'
import SensitiveTerms from './details/SensitiveTerms.vue'
import PrivacyThirdTerms from './details/PrivacyThirdTerms.vue'
import SensitiveThirdTerms from './details/SensitiveThirdTerms.vue'

export default {
  components: {
    Close,
    ServiceTerms,
    PersonalInfoTerms,
    MarketingTerms,
    PrivacyCollectionTerms,
    PrivacyOfferTerms,
    PersonalInformationAgreement,
    // #15004
    PersonalInfoTermsAll,
    // #14754
    PrivacyTerms,
    SensitiveTerms,
    PrivacyThirdTerms,
    SensitiveThirdTerms
  },
  props: {
    dialog: Boolean,
    flag: {
      type: Number,
      default: 0
    },
    name: String
  },
  data: () => ({
    // title: ['서비스 이용 약관', '개인정보 수집 및 이용 동의', '마케팅 수신 동의', '개인정보 처리방침', '개인정보 수집 동의', '개인정보 제공 동의', '개인정보 제공 동의'],
    terms: [
      { flag: 0, title: '서비스 이용 약관', components: ServiceTerms }, // 찐한대화 부분 삭제 X 추후 확인
      { flag: 1, title: '개인정보 수집 및 이용 동의', components: PersonalInfoTerms },
      { flag: 2, title: '마케팅 수신 동의', components: MarketingTerms },
      { flag: 4, title: '개인정보 수집 동의', components: PrivacyCollectionTerms },
      { flag: 5, title: '개인정보 제공 동의', components: PrivacyOfferTerms },
      { flag: 6, title: '개인정보 제공 동의', components: PersonalInformationAgreement },
      // #15004
      { flag: 3, title: '개인정보 처리방침', components: PersonalInfoTermsAll },
      // #14754
      { flag: 7, title: '개인정보 수집 및 이용 동의', components: PrivacyTerms },
      { flag: 8, title: '민감정보 수집 및 이용 동의', components: SensitiveTerms },  // 찐한대화 문구 삭제
      { flag: 9, title: '개인정보 제3자 제공 동의', components: PrivacyThirdTerms },  // 찐한대화만 노출
      { flag: 10, title: '민감정보 제3자 제공 동의', components: SensitiveThirdTerms } // 찐한대화만 노출
    ],
    currentView: { title: null, components: null }
  }),
  watch: {
    dialog: {
      immediate: true,
      handler (nV) {
        if (nV) {
          this.currentView = this.terms.filter(value => value.flag === this.flag)[0]
        } else {
          this.currentView = { title: null, components: null }
        }
      }
    }
  },
  created() {
    console.log(this.currentView)
  },
  mounted() {},
  methods: {}
}
</script>

